//TODO: No está acabada
/**
 * Directiva para elegir una fecha
 */
export default function datepicker() {
    return {
        restrict: 'AE',
        require: 'ngModel',
        replace: true,
        template: '<input type="text">',
        link: function (scope, element, attrs, ngModelCtrl) {
            $(function () {
                var actualizarModelo = function (fecha) {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(fecha);
                    });
                };
                element.datepicker({
                        regional: "es",
                        dateFormat: "dd/mm/yy", //Se le debería pasar
                        onSelect: function (fecha) {
                            actualizarModelo(fecha);
                        },
                        showOptions: {direction: "up"}
                    }
                );
                //console.log(new Date('15/08/1991'));
                //var day = moment("15/08/1991", "MM/DD/YYYY");
                //console.log(day.toDate());
                //element.datepicker("getDate", new Date('15/08/1991'));
                //element.val('15/08/1991');
                //scope.$watch(attrs.ngModel, function (data) {
                //    var fecha = element.datepicker("getDate");
                //    console.log(typeof fecha);
                //    console.log(data);
                //    // Todo, si no es una fecha, la crea igual
                //    console.log(new Date(fecha));
                //    console.log(element.datepicker("getDate"));
                //    console.log(new Date());
                //    if (fecha != 'undefined') {
                //        if (typeof element.val() !== 'undefined') {
                //            element.daterangepicker("clearRange");
                //        }
                //    } else {
                //        element.val('15/08/1991');
                //        // TODO: Falta actualizar el valor, por si se quiere cambiar el modelo desde otro lado
                //    }
                //});
            });
        }
    }
}